import { SettingsPermissions } from "@redotech/account-common/permissions";
import { directMerchantAccess } from "../../settings-catalog/access";
import type {
  SettingGroupDefinition,
  SettingOwner,
  SettingRisk,
} from "../../settings-catalog/types";

export type ShippingFulfillmentPromiseFlatTeamSettingGroupId =
  "shipping_fulfillment_promise.fulfillment_cutoff";

const groupOwner: SettingOwner = {
  kind: "teamSettings",
  product: "fulfillment",
};

const groupRisk: SettingRisk = {
  level: "low",
  reason:
    "Order cutoff times and promise days behind the shopper-facing delivery estimate.",
};

export const ShippingFulfillmentPromiseFlatTeamSettingGroups = [
  {
    id: "shipping_fulfillment_promise.fulfillment_cutoff",
    title: "Fulfillment cutoff",
    description:
      "The per-day order cutoff times and fulfillment promise days behind the delivery estimate shown to shoppers.",
    productArea: "fulfillment",
    access: directMerchantAccess(SettingsPermissions.SET_SHIPPING_SETTINGS),
    owner: groupOwner,
    risk: groupRisk,
    agentEditability: { mode: "requiresApproval" },
    fullPageTarget: { type: "settings", path: "fulfillment-cutoff" },
    synonyms: ["fulfillment cutoff", "shipping fulfillment promise"],
  },
] as const satisfies readonly SettingGroupDefinition<ShippingFulfillmentPromiseFlatTeamSettingGroupId>[];

type _assertAllShippingFulfillmentPromiseFlatTeamSettingGroupIdsProvided =
  ShippingFulfillmentPromiseFlatTeamSettingGroupId extends (typeof ShippingFulfillmentPromiseFlatTeamSettingGroups)[number]["id"]
    ? true
    : never;
const _allShippingFulfillmentPromiseFlatTeamSettingGroupIdsProvided: _assertAllShippingFulfillmentPromiseFlatTeamSettingGroupIdsProvided = true;
void _allShippingFulfillmentPromiseFlatTeamSettingGroupIdsProvided;

export const ShippingFulfillmentPromiseFlatTeamSettingGroupById: Record<
  ShippingFulfillmentPromiseFlatTeamSettingGroupId,
  SettingGroupDefinition<ShippingFulfillmentPromiseFlatTeamSettingGroupId>
> = (() => {
  const map: Partial<
    Record<
      ShippingFulfillmentPromiseFlatTeamSettingGroupId,
      SettingGroupDefinition<ShippingFulfillmentPromiseFlatTeamSettingGroupId>
    >
  > = {};
  for (const group of ShippingFulfillmentPromiseFlatTeamSettingGroups) {
    map[group.id] = group;
  }
  return map as Record<
    ShippingFulfillmentPromiseFlatTeamSettingGroupId,
    SettingGroupDefinition<ShippingFulfillmentPromiseFlatTeamSettingGroupId>
  >;
})();
